export interface GdPanelSection {
  id: string;
  title: string;
  description: string;
  placeholderLabel: string;
  placeholderHint: string;
  placeholderVariant: "wide" | "phone" | "screen";
  featuresLeft: string[];
  featuresRight: string[];
  imagePosition: "left" | "right";
}

export interface GdWorkflowStep {
  title: string;
  text: string;
}

export interface GdBusinessModel {
  title: string;
  placeholderLabel: string;
  placeholderHint: string;
}

export const gdCustomerFeaturesLeft = [
  "Register/Login",
  "User Profile Management",
  "Help Desk",
  "Manage Notification Preference",
  "Advance Search Filter",
  "Access Product Sort wise",
  "Location Based Product Listing",
  "Product Details",
  "Wish List",
  "Order Cancellation",
];

export const gdCustomerFeaturesRight = [
  "Order History",
  "Reviews and Ratings",
  "Easy Checkout",
  "Detailed Categories",
  "Product Listing",
  "Checkout",
  "Order Cancel & Re Order",
  "Order Tracking",
  "Vendor Information",
  "Payment Gateway Integration",
];

export const gdDeliveryBoyFeatures = [
  "Profile",
  "Push Notifications",
  "Assigned Orders",
  "Accept Delivery",
  "GPS Navigation Map",
  "Delivery Status Update",
  "Check Payment Status",
  "One-Click Call To Customers",
];

export const gdAdminFeaturesLeft = [
  "Authentication",
  "One Click Dashboard",
  "Push Notification",
  "Brand Management",
  "Category Management",
  "Sub Category Management",
  "Measuring Units Management",
  "Product Management",
];

export const gdAdminFeaturesRight = [
  "Vendor Management",
  "Subscription Plan",
  "Profile Management",
  "Offers and Discount Management",
  "User Management",
  "Pay & Commission Management",
  "Email & SMS Campaign",
  "Insights & Report",
];

export const gdVendorFeaturesLeft = [
  "Profile",
  "Dashboard",
  "Push Notification",
  "Branch Management",
  "Staff Management",
  "Delivery Scheduling",
  "Delivery Area Management",
  "Banner Management",
];

export const gdVendorFeaturesRight = [
  "Special Offers / Coupon Code",
  "Product Management",
  "Order Management",
  "Cancellation Management",
  "Review management",
  "Transaction History",
  "Financial Information",
  "Insights and Report",
];

export const gdWorkflowSteps: GdWorkflowStep[] = [
  {
    title: "Customer Registration",
    text: "Shoppers register or log in, set delivery preferences, and browse nearby stores, brands, and product categories.",
  },
  {
    title: "Product Discovery",
    text: "Customers search and filter products by location, category, and sort order — adding items to cart with size and quantity options.",
  },
  {
    title: "Vendor Processing",
    text: "Grocery vendors receive orders through their panel, manage inventory, apply offers, and prepare items for dispatch.",
  },
  {
    title: "Delivery Assignment",
    text: "The system assigns orders to available delivery personnel based on proximity, schedule, and delivery area coverage.",
  },
  {
    title: "Live GPS Tracking",
    text: "Delivery boys navigate via GPS maps while customers track order status in real time and communicate with one-click calling.",
  },
  {
    title: "Payment & Feedback",
    text: "Payments are processed seamlessly, transaction history is recorded, and customers leave reviews to build vendor trust.",
  },
];

export const gdBusinessModels: GdBusinessModel[] = [
  {
    title: "Grocery Stores App for Single Store",
    placeholderLabel: "Single Store App",
    placeholderHint: "Local grocery shop · Direct ordering",
  },
  {
    title: "Multi-Vendor Grocery Marketplaces",
    placeholderLabel: "Multi-Vendor Marketplace",
    placeholderHint: "Multiple stores · Aggregator model",
  },
  {
    title: "Grocery App for Grocery Chain Stores",
    placeholderLabel: "Chain Store App",
    placeholderHint: "Multi-branch · Centralised management",
  },
];

export const gdBenefits = [
  "Easy Inventory Management",
  "Hassle-free Order Management",
  "Enhance Customer Loyalty",
  "Can be Personalized to Customers",
  "Boost Sales & Visibility",
  "Seamless Payments",
  "Wide Product Accessibility",
  "Time & Cost Efficient",
  "24/7 Shopping Available",
];

export const gdCompanyOffers = [
  "Quick Technical Support",
  "A Team of 30+ developers",
  "Packages that don't burn a hole in your pocket",
  "Complete walk around of your project",
  "On or before time delivery",
];

export const gdPanels: GdPanelSection[] = [
  {
    id: "admin",
    title: "Grocery App Admin Panel",
    description:
      "A fully-integrated & secured admin panel to manage all business aspects of the grocery delivery application.",
    placeholderLabel: "Admin Dashboard",
    placeholderHint: "Orders · Earnings · Vendor management",
    placeholderVariant: "wide",
    featuresLeft: gdAdminFeaturesLeft,
    featuresRight: gdAdminFeaturesRight,
    imagePosition: "left",
  },
  {
    id: "vendor",
    title: "Grocery Store Vendor Panel",
    description:
      "A real-time Grocery vendor dashboard to manage products, orders, discounts etc.",
    placeholderLabel: "Vendor Dashboard",
    placeholderHint: "Products · Orders · Branch management",
    placeholderVariant: "screen",
    featuresLeft: gdVendorFeaturesLeft,
    featuresRight: gdVendorFeaturesRight,
    imagePosition: "right",
  },
];
